<template>
    <div class="law-header">
        <div class="header-main" :class="isLawyerConfirmPage ? 'header-main-confirm' : ''">
            <div class="column">
                <div class="logo">
                    <div>
                        <img class="logo-pic" :src="ind[industry].logo"/>
                        <span class="line"></span>
                        <span class="logo-name">百度旗下专业法律服务平台</span>
                    </div>
                </div>
            </div>
            <div v-if="isShowUser" class="user">
                <!-- <Poptip
                    v-if="isShowMsg && !isLawyerConfirmPage"
                    v-model="msgtab"
                    trigger="hover"
                    class="msg-poptip"
                > -->
                <!-- 律师任务中心-律师端才有 -->
                <!-- <task-center v-if="+userInfoNew.user_role === 0 && isNotRoute"></task-center> -->
                <div
                    v-if="isShowMsg && !isLawyerConfirmPage"
                    class="msg-box"
                >
                    <veui-badge
                        v-if="statistics.unread && +statistics.unread !== 0"
                        class="msg"
                        :value="statistics.unread"
                        @click.native="viewMsg"
                    >
                        <img src="https://lvlin-base.bj.bcebos.com/fe-saas/component/header/bell.png"/>
                    </veui-badge>
                    <div
                        v-else
                        class="msg"
                        @click="viewMsg"
                    >
                        <img src="https://lvlin-base.bj.bcebos.com/fe-saas/component/header/bell.png"/>
                    </div>
                    <!-- ui样式改版，下线消息中心pop -->
                    <!-- <div slot="content" class="ivu-table-filter-list">
                        <div
                            v-if="!isLawyerConfirmPage"
                            class="ivu-table-filter-select-item msg-info"
                            :pointer="!isMsgPage"
                            @click="viewMsg"
                        >
                            消息中心{{
                                statistics.total ? `(${statistics.total})` : ""
                            }}
                        </div>
                    </div> -->
                </div>
                <!-- </Poptip> -->
                <span class="user-line"></span>
                <div class="user-set">
                    <Poptip
                        v-model="usertab"
                        class="usertip"
                        trigger="hover"
                        placement="bottom"
                    >
                        <div class="info">
                            <div class="info-icon">
                                <img
                                    src="https://lvlin-base.bj.bcebos.com/fe-saas/component/header/user-icon.png"
                                    alt=""
                                />
                            </div>
                            <div pointer>
                                {{ name }}
                            </div>
                        </div>
                        <div slot="content">
                            <div class="ivu-table-filter-list">
                                <ul class="ivu-table-filter-list-single">
                                    <li
                                        v-if="!isUc"
                                        class="ivu-table-filter-select-item"
                                        @click="usertab = false"
                                    >
                                        <p pointer @click="goToPassSetting">
                                            账号设置
                                        </p>
                                    </li>
                                    <li
                                        v-if="!isSettlePage && !isLawyerConfirmPage"
                                        class="ivu-table-filter-select-item"
                                        @click="usertab = false"
                                    >
                                        <p pointer @click="goToMaterial">
                                            个人资料
                                        </p>
                                    </li>
                                    <li class="ivu-table-filter-select-item">
                                        <p pointer @click="lawLogout">退出</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Poptip>
                </div>
                <div
                    v-if="showNewVideoTemplateTip"
                    v-visually="{
                        serverId: 20099,
                        area: 'new-video-modal',
                    }"
                    class="new-video-template-tip"
                >
                    <div class="new-video-template-tip-title">
                        <span class="new-video-template-tip-title-icon"></span>
                        您有新的视频模板待启用
                        <span
                            class="new-video-template-tip-title-close"
                            @click="clickClose"
                        ></span>
                    </div>
                    <div class="new-video-template-tip-content">
                        您有新的视频模板审核通过待启用，请尽快查看效果并启用，提升数字人视频质量
                    </div>
                    <div
                        class="new-video-template-tip-btn"
                        @click="toHotQuestion"
                    >
                        立即查看
                    </div>
                </div>
            </div>
            <!-- 授权成功弹窗 -->
            <vip-authorize-modal
                :show="isAuthorizeShow"
                :authorized="true"
                @cancel="isAuthorizeShow = false"
            />
            <!-- 弹窗管理 -->
            <c-popup
                @showAuthModal="isAuthorizeShow = true"
                @carouselChange="carouselChange"
            />
        </div>
    </div>
</template>

<script>
/**
 * @desc 法律 header
 * @author baoleilei<baoleilei@baidu.com>
 * @file lawHeader.vue
 * @date 2020-09-25
 */

import {mapState, mapActions, mapMutations} from 'vuex';
import {Badge} from 'veui';
import 'veui-theme-dls-icons/envelope';
import {passportOrigin} from '../../config/constant';
import get from 'lodash/get';
import VipAuthorizeModal from '@/components/vip/vip-authorize-modal';
import taskCenter from './law/task-center.vue';
import dayjs from 'dayjs';
import Popup from './popup/Popup.vue';
import {AsyncQueue} from '@/utils/asyncQueue.js';

const url = {
    // 消息统计
    statisticsMsg: '/bp/api/msg/statistics',
    functionRelease: 'law:/themis/law/msg/functionrelease',
    // 新消息推送
    gerMessageData: '/bp/functionrelease/getfunctionrelease'
};

// 不跳转首页的路由
const notGoHomeRouters = ['setting', 'home', 'Select'];
export default {
    name: 'lawHeader',
    components: {
        'veui-badge': Badge,
        'vip-authorize-modal': VipAuthorizeModal,
        'task-center': taskCenter,
        'c-popup': Popup
    },
    created() {
        // 获取队列实例
        this.asyncQueue = AsyncQueue.getInstance();
    },
    data() {
        return {
            usertab: false,
            msgtab: false,
            industry: 'law',
            passSettingUrl: `${passportOrigin}/v6/ucenter?_t${parseInt(
                Date.now() / 1000,
                10
            )}`,
            isRuningDialog: false, // 是否运行弹窗函数
            editDialogShow: false, // 是否展示认证确认弹窗
            // 消息列表
            messageList: null,
            isLawyerConfirmPage: false,
            isFromFirmAuth: false,
            isAuthorizeShow: false, // 授权成功弹窗
            asyncQueue: null, // 弹窗队列实例
            showNewVideoTemplateTip: false
        };
    },
    methods: {
        ...mapMutations({
            setStatistics: 'Statistics/setStatistics'
        }),
        ...mapActions({
            logout: 'logout'
        }),
        goToPassSetting() {
            window.open(this.passSettingUrl);
        },
        lawLogout() {
            sessionStorage.removeItem('accountComplete');
            const {authToken} = this.$route.query || {};
            this.logout(authToken);
        },
        goToMaterial() {
            // 律所
            if (this.userInfoNew.user_role === 2) {
                this.$route.name !== 'firmintro' && this.$router.push({
                    name: 'firmintro',
                    query: {
                        viewMsg: true
                    }
                });
                return;
            }
            if (this.$route.name !== 'material') {
                this.$router.push({
                    name: 'material',
                    query: {
                        viewMsg: true
                    }
                });
            }
        },
        /**
         * 处理弹窗事件
         */
        runDialog() {
            if (this.$route.name === 'claim-lawyer') {
                return;
            }
            if (this.isRuningDialog) {
                return;
            }
            const today = new Date().toISOString().slice(0, 10);
            if (
                Object.keys(this.userInfoNew).length
                && this.messageList
                && Object.keys(this.vipInfo).length
                && this.authenticationStatus
            ) {
                // 智能体创建弹窗-新
                // this.showCreateAgentNewDialog();

                // 判断本地缓存的和当前时间是否相等，如果不想等，判断百家号状态判断是否展示
                this.isRuningDialog = true;
                let {uk} = this.vipInfo || {};
                let msgWatchList = JSON.parse(localStorage.getItem(
                    `${uk}_newMsgWatchList`) || '[]');
                // 是否有新消息
                let isHasNewMsg = false;
                for (let i = 0; i < this.messageList.length; i++) {
                    let msgItem = this.messageList[i];
                    // 有新的推送消息
                    if (msgWatchList.indexOf(msgItem.id) < 0) {
                        isHasNewMsg = true;
                        this.carouselChange({...this.messageList[0], index: 0});
                        break;
                    }
                }

                // amis弹窗
                if (
                    this.userInfoNew.user_role === 0
                    && !this.isSettlePage
                    && isHasNewMsg
                ) {
                    // 展示弹窗
                    this.asyncQueue.push({
                        type: 'ui-carousel',
                        params: {
                            type: 'show',
                            data: {
                                componentName: 'ui-carousel',
                                componentData: {
                                    list: this.messageList || []
                                }
                            }
                        }
                    });

                    // 消息弹窗曝光
                    this.$wywLog.send({
                        serverId: 16506,
                        action: 'show',
                        page: 'lawinfo',
                        area: 'dialog',
                        index: 0,
                        activityId: this.messageList[0] && this.messageList[0].id
                    });
                    return;
                }


                // 智能体弹窗
                const lastShownDate = localStorage.getItem(`${uk}_agentCreateDialogLastShownDate`);
                // 智能体未创建且认证通过
                const isShow = (this.agentInfo?.is_create === 1 && this.authenticationStatus === 7) || false;
                // 如果上次显示日期不存在或不是今天
                if ((!lastShownDate || lastShownDate !== today) && isShow) {
                    this.asyncQueue.push({
                        type: 'agent-create-dialog',
                        params: {
                            type: 'show',
                            data: {
                                componentName: 'agent-create-dialog'
                            }
                        }
                    });
                    this.$wywLog.send({
                        area: 'agent-create-dialog',
                        action: 'show',
                        serverId: 19291
                    });
                    localStorage.setItem(`${uk}_agentCreateDialogLastShownDate`, today);

                    return;
                }

                // 会员过期弹窗
                if (this.userInfoNew.user_role === 0) {
                    // 免费会员领取/失效弹窗逻辑
                    const freeVipModalShow
                        = localStorage.getItem('freeVipModalShow');
                    const receiveFreeVipTimer = localStorage.getItem('receiveFreeVipTimer');
                    const {canReceiveFreeVip, vipStatus, privilege_info, validityEnd} = this.vipInfo;
                    // freeVipTimer：免费体验会员临期弹窗展示时间
                    const freeVipTimer = localStorage.getItem('aboutToExpireFreeVipTimer');
                    const date1 = freeVipTimer ? dayjs(freeVipTimer).format('YYYY-MM-DD') : '';
                    const date2 = dayjs().format('YYYY-MM-DD');
                    const remainDays = dayjs(validityEnd)?.diff(dayjs(), 'day');
                    let freeVipModalType = '';
                    // 能领取免费体验会员，展示领取弹窗
                    if (canReceiveFreeVip) {
                        const crm_enter_type = this.lawyerInfo?.crm_enter_type || {};
                        freeVipModalType = crm_enter_type === 2 ? 'receive' : '';
                    }
                    // 非会员，且最近过期的是免费体验会员，展示过期弹窗
                    else if (
                        !+vipStatus
                        && privilege_info
                        && privilege_info.vip_code_type === 6
                    ) {
                        freeVipModalType = 'expire-no-avatar';
                    }
                    // 免费体验会员失效的T-3日增加引导弹窗，一天只展示一次
                    else if (remainDays <= 3 && remainDays >= 0 && (!freeVipTimer || date1 !== date2)) {
                        freeVipModalType = 'about-to-expire';
                    }
                    const isShowFreeVipModal
                        = !this.isSettlePage
                            && !this.isFromFirmAuth
                            && this.authenticationStatus >= 7;

                    if (freeVipModalType === 'receive' && isShowFreeVipModal) {
                        if (
                            !receiveFreeVipTimer
                            || (receiveFreeVipTimer
                                && +new Date() - receiveFreeVipTimer > 7 * 24 * 3600 * 1000)
                        ) {

                            this.asyncQueue.push({
                                type: 'free-vip-dialog',
                                params: {
                                    type: 'show',
                                    data: {
                                        componentName: 'free-vip-dialog',
                                        componentData: {
                                            type: freeVipModalType
                                        }
                                    }
                                }
                            });

                            return;
                        }
                    }
                    else if (freeVipModalShow !== freeVipModalType && isShowFreeVipModal) {
                        this.asyncQueue.push({
                            type: 'free-vip-dialog',
                            params: {
                                type: 'show',
                                data: {
                                    componentName: 'free-vip-dialog',
                                    componentData: {
                                        type: freeVipModalType
                                    }
                                }
                            }
                        });

                        return;
                    }
                }
                this.getAccountInfo();
            }
        },
        viewMsg() {
            if (this.$route.name !== 'lawMessageInfo') {
                this.$router.push({
                    name: 'lawMessageInfo'
                });
            }
        },
        // 消息统计信息
        getStatistics() {
            if (
                this.industry === 'law'
                && !location.href.includes('filldata')
            ) {
                this.$http
                    .get(url.statisticsMsg)
                    .then(res => {
                        if (!res || +res?.code !== 0) {
                            this.$Message.error({
                                content: res.msg || '数据请求出错',
                                duration: 5
                            });
                            return;
                        }
                        const data = res?.data || {};
                        if (data) {
                            this.setStatistics(data);
                        }
                    })
                    .catch(error => {
                        this.$Message.error({
                            content: error.msg || '数据请求出错',
                            duration: 5
                        });
                    });
            }
        },
        getAccountInfo() {
            const accountComplete = sessionStorage.getItem('accountComplete');
            const consultInfo = get(this.userInfoNew, 'consult_info');
            // 如果本地缓存accountComplete为true，或者userinfo数据未更新的情况，直接返回，不往下请求
            if (accountComplete === 'true' || !consultInfo) {
                return;
            }
            this.$http.get('/bp/api/account/info').then(res => {
                const accountInfo = this.$normalizeResponseData(res);
                // 认证律师未填写银行账号需要弹窗提示
                if (accountInfo && accountInfo.audit_status) {
                    this.editDialogShow
                        = accountInfo.can_modifi
                            && !!+consultInfo.twenty_minute_price;
                    sessionStorage.setItem(
                        'accountComplete',
                        this.editDialogShow
                    );
                }
            });
        },

        /**
         *
         * 百家号相关跳转逻辑
         */

        goToBjh() {
            const bjhRegisterdStatus = this.bjhInfo?.bjh_registerd_status; // 百家号注册状态
            const bjhInfo = this.bjhInfo?.bjh_info || {};
            const subType = bjhInfo.sub_type; // 百家号注册账号type
            // 未注册百家号或百家号注册未通过或百家号账号不是个人账号，跳转百家号注册页面
            if (
                +bjhRegisterdStatus === 0
                || bjhInfo.status === 'unpass'
                || subType !== 'individual'
            ) {
                this.$router.push({
                    name: 'bjhRegister'
                });
                return;
            }
            const toPath = this.bjhNextPath; // 百家号跳转路径
            if (toPath) {
                window.open(toPath);
            }
        },
        /**
         * 请求消息推送信息
         */
        getMessageData() {
            let {vipStatus, privilege_info = {}} = this.vipInfo || {};
            this.$http
                .get(url.gerMessageData, {
                    params: {
                        vip_code_type: privilege_info && privilege_info.vip_code_type || '',
                        vip_status: vipStatus,
                        notification_platform: 1
                    }
                })
                .then(res => {
                    const info = this.$normalizeResponseData(res);
                    this.messageList = info.function_release_list || [];
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.messageList = [];
                });
        },
        /**
         * 新消息推送-轮播切换
         * @param {object} info 轮播信息
         */
        carouselChange(info) {
            let {id, index} = info || {};
            let {uk} = this.vipInfo || {};
            let watchList = JSON.parse(localStorage.getItem(
                `${uk}_newMsgWatchList`) || '[]');
            // 消息弹窗曝光
            this.$wywLog.send({
                serverId: 16506,
                action: 'show',
                page: 'lawinfo',
                area: 'banner',
                index,
                activityId: id
            });
            if (watchList.indexOf(id) > -1) {
                return;
            }
            watchList.push(id);
            localStorage.setItem(
                `${uk}_newMsgWatchList`, JSON.stringify(watchList));
        },
        showCreateAgentNewDialog() {
            // 智能体创建弹窗-新
            let showCreateAgentDialog = (this.authenticationStatus === 7 && this.agentInfo.is_create === 1) || false;
            if (showCreateAgentDialog) {
                this.asyncQueue.push({
                    type: 'agent-create-dialog',
                    params: {
                        type: 'show',
                        data: {
                            componentName: 'agent-create-dialog-new'
                        }
                    }
                });
                return;
            }
        },
        toHotQuestion() {
            this.$wywLog.send({
                serverId: 20099,
                action: 'click',
                area: 'new-video-modal-btn'
            });
            this.showNewVideoTemplateTip = false;
            this.$router.push({
                name: 'hotQuestion',
                query: {showVideoTempModal: '1'}
            });
        },
        clickClose() {
            this.$wywLog.send({
                serverId: 20099,
                action: 'click',
                area: 'new-video-modal-close-btn'
            });
            this.showNewVideoTemplateTip = false;
        },
        getVideoList() {
            this.$http.get('/bp/videotemplate/list', {
                params: {
                    pn: 1,
                    rn: 100,
                    gen_type: 1,
                    video_template_status: 2,
                    audit_status: 1
                }
            }).then(res => {
                if (res.code === '0' && res.data && res.data.list && res.data.list.length > 0) {
                    // 审核通过待启用
                    let videoTemplateList = res.data.list
                        .filter(item => item.audit_status === 1 && !item.selected).map(item => item.id);
                    let uk = this.userInfoNew?.uk;
                    let lastIdList = localStorage.getItem(`${uk}_lastIdList`)?.split(',') || [];
                    if (videoTemplateList.length) {
                        this.showNewVideoTemplateTip = !videoTemplateList
                            .every(item => lastIdList.includes((item + '')));
                    }
                }
            }).catch(err => {});
        }
    },
    watch: {
        userInfoNew() {
            this.runDialog();
        },
        bjhInfo() {
            this.runDialog();
        },
        vipInfo: {
            deep: true,
            immediate: true,
            handler(val) {
                if (val) {
                    const {authToken} = this.$route.query || {};
                    if (authToken) {
                        return;
                    }
                    this.getMessageData();
                }
            }
        },
        bjhNextPath: {
            immediate: true,
            deep: true,
            handler(next) {
                if (next) {
                    this.goToBjh();
                }
            }
        },
        messageList() {
            this.runDialog();
        },
        authenticationStatus: {
            immediate: true,
            handler(val) {
                this.runDialog();
            }
        },
        agentInfo() {
            this.runDialog();
        },
        '$route.query'(val) {
            this.isFromFirmAuth = !!val.formFirmAuth;
            this.runDialog();
        }
    },
    computed: {
        ...mapState({
            bjhInfo: state => state?.lawStore?.bjhInfo,
            userInfoNew: state => state?.lawStore?.userInfoNew,
            authenticationStatus: state =>
                state.lawStore.authenticationStatus,
            vipInfo: state => state.lawStore.vipInfo,
            ind: state => state.Industry.ind,
            statistics: state => state.Statistics.statistics,
            bjhNextPath: state => state.lawStore.bjhNextPath,
            passInfo: state => state.lawStore.userInfoNew?.pass_info || {},
            ucType: state => state.lawStore.userInfoNew?.uc_shadow_type,
            lawBusinessInfo: state => state?.lawStore?.userInfoNew?.law_business_info || {},
            lawyerInfo: state => state?.lawStore?.userInfoNew?.lawyer_info || {},
            agentInfo: state => state.lawStore?.agentInfo,
            consultInfo: state => state.lawStore?.userInfoNew?.consult_info,
            authorization: state => state.lawStore?.userInfoNew?.authorization || {}
        }),
        notGoHome() {
            return notGoHomeRouters.includes(this.$route.name);
        },
        isMsgPage() {
            return this.$route.name === 'lawinfo' && this.$route.query.viewMsg;
        },
        isShowUser() {
            return this.$route.name !== 'introduce-bjh';
        },
        isNotRoute() {
            return this.$route.name !== 'claim-lawyer';
        },
        isShowMsg() {
            let blackList = ['filldata'];
            // uc用户
            if (this.isUc) {
                return false;
            }
            return !blackList.includes(this.$route.name);
        },
        isSettlePage() {
            // uc用户
            if (this.isUc) {
                return true;
            }
            return ['filldata', 'introduce-bjh'].includes(this.$route.name);
        },
        isUc() {
            return +this.ucType === 1;
        },
        name() {
            const {user_role, law_business_info, pass_info} = this.userInfoNew || {};
            if (user_role === 2 && law_business_info && (law_business_info.name || law_business_info.team_name)) {
                return law_business_info.name + law_business_info.team_name;
            }
            return (pass_info?.pass_name || pass_info?.uname) + '律师';
        }
    },
    mounted() {
        const {authToken} = this.$route.query || {};
        if (authToken) {
            this.isLawyerConfirmPage = true;
            return;
        }
        this.getStatistics();
        this.getVideoList();
    }
};
</script>

<style scoped lang="less">
@import "../assets/css/base.less";

.law-header {
    position: relative;
    width: 100%;
    background-color: #f8f9fc;
    box-shadow: 0 0 0 0;
    border-bottom: 1px solid rgba(222, 223, 224, .3);
    .clearfix();

    z-index: 100;

    .msg {
        position: relative;
        top: 4px;
        vertical-align: middle;

        img {
            width: 18px;
            height: 25px;
            object-fit: cover;
        }
    }

    .envelope {
        font-size: 15px;
    }

    .header-main {
        margin: 0 auto;
        width: 1338px;
        height: 64px;
        line-height: 64px;
        box-sizing: border-box;
        // 解决菜单消失后还可以hover的问题：原因是有一个fade的过程
        /deep/ .du-poptip-popper.fade-leave-to {
            pointer-events: none;
        }

        .column {
            float: left;
            display: flex;
            height: 100%;
            align-items: center;

            .logo {
                position: relative;
                margin-right: 16px;

                a {
                    display: flex;
                    align-items: center;
                }

                div {
                    display: flex;
                    align-items: center;
                }
            }

            .logo-car {
                height: 72px !important;
            }

            .logo-pic {
                height: 24px;
                width: 157px;
                display: inline-block;
                vertical-align: middle;
            }

            .logo-name {
                font-size: 14px;
                color: #696969;
                vertical-align: middle;
                line-height: 1;
            }

            .line {
                height: 16px;
                width: 1px;
                display: inline-block;
                background: #e9ecf3;
                margin: 0 10px;
            }

            .title {
                font-size: 16px;
                color: #333;
            }
        }

        .user {
            display: flex;
            align-items: center;
            position: relative;
            float: right;
            line-height: 1;
            color: #333;
            height: 100%;

            .msg-box {
                cursor: pointer;
                margin-right: 16px;
            }

            .msg-poptip {
                margin-right: 18px;

                /deep/ .ivu-poptip-popper {
                    width: 140px;
                    min-width: 140px;
                    text-align: center;
                }

                /deep/ .ivu-poptip-body {
                    padding: 0;
                }

                .ivu-table-filter-list {
                    padding: 0;
                }
            }

            .user-line {
                display: inline-block;
                width: 1px;
                height: 16px;
                background-color: #d3d9e5;
                margin-right: 15px;
            }

            .msg-info {
                font-size: 14px;
                color: #282c33;
                line-height: 30px;
            }

            .info {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                font-family: PingFangSC-Medium;
                font-size: 16px;
                color: #1e1f24;

                .info-icon {
                    display: block;

                    img {
                        width: 18px;
                        vertical-align: middle;
                        margin-right: 6px;
                    }
                }

                .name {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: #333;
                    line-height: 14px;
                }
            }

            .rank {
                background: #4a7cff;
                border-radius: 10px;
                color: #fff;
                padding: 0 8px;
                font-size: 12px;
                margin-left: 7px;
            }

            .oldhand {
                background: #0067ff;
            }
        }
        // 菜单
        /deep/ .ivu-poptip-inner {
            padding: 0;
        }

        .ivu-table-filter-select-item {
            font-size: 14px !important;
            color: #282c33;

            &:first-child {
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }

            &:last-child {
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
            }
        }
        // 信息提示
        /deep/ .veui-badge-label {
            text-align: center;
        }

        .user-set {
            /deep/.ivu-table-filter-select-item {
                padding: 0 30px;
            }
        }

        .new-video-template-tip {
            background: #fff;
            width: 352px;
            border-radius: 9px;
            position: absolute;
            top: 76px;
            right: 0;
            box-shadow: 0 6px 18px 0 #0000001a;
            padding: 18px;

            .new-video-template-tip-title {
                color: #1e1f24;
                font-family: PingFang SC;
                font-weight: 500;
                font-style: Medium;
                font-size: 16px;
                line-height: 16px;
                display: flex;
                align-items: center;

                .new-video-template-tip-title-icon {
                    height: 20px;
                    width: 20px;
                    margin-right: 8px;
                    background: url("https://lvlin-fe-saas.cdn.bcebos.com/hotQuestion/new-video-tip-modal/%23icon.png") no-repeat center center / 100% 100%;
                }

                .new-video-template-tip-title-close {
                    height: 20px;
                    width: 20px;
                    position: absolute;
                    right: 18px;
                    top: 18px;
                    cursor: pointer;
                    background: url("https://lvlin-fe-saas.cdn.bcebos.com/hotQuestion/new-video-tip-modal/close.png") no-repeat center center / 100% 100%;
                }
            }

            .new-video-template-tip-content {
                color: #50525c;
                font-family: PingFang SC;
                font-weight: 400;
                font-style: Regular;
                font-size: 14px;
                line-height: 22px;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .new-video-template-tip-btn {
                background: #0055ff1a;
                width: 80px;
                height: 34px;
                opacity: 1;
                border-radius: 6px;
                color: #05f;
                font-family: PingFang SC;
                font-weight: 500;
                font-style: Medium;
                font-size: 14px;
                line-height: 34px;
                text-align: center;
                float: right;
                cursor: pointer;
            }
        }
    }

    .header-main-confirm {
        width: 1280px;
    }
}

.edit-dialog-content {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #000;
    letter-spacing: 0;
    line-height: 30px;
}
</style>
